import React from 'react';
import PropTypes from 'prop-types';

import Form from '../../../../../components/Form';

import '../../styles.css';

const NumberInputComponent = ({ name, value, onChange, stylesName, icon, placeholder }) => (
  <div styleName={stylesName} data-cy={`Premium-Hem-${name}-Container`}>
    <Form.Input
      fluid
      min="0"
      icon={icon}
      type="number"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      data-cy={`Premium-Hem-${name}-InputField`}
    />
  </div>
);

NumberInputComponent.propTypes = {
  icon: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  stylesName: PropTypes.string,
  placeholder: PropTypes.string,
};

export default NumberInputComponent;
